<div class="wrapper-search-status">
  <span>{{ searchParams().q }}</span>
  <!--<ui-icon faStyle="light" faName="filter"></ui-icon>-->
</div>
